'use client';

import { type FC } from 'react';
import { RushMidTabs } from './RushMidTabs';
import type { RushMidTab } from '../RushMidGame';

/** The tab filter shown at the top of every Rush Mid tab screen (games / fighter /
 *  history / rating). The rules live behind the games home's «как играть» link. */
export const RushMidTabsBar: FC<{ activeTab: RushMidTab; onChange: (tab: RushMidTab) => void }> = ({ activeTab, onChange }) => (
  <RushMidTabs activeTab={activeTab} onChange={onChange} />
);
